import React, { useContext } from 'react';
import Language from '../../../common/decorators/Language';
import Single from '../../../layouts/single/Single/Single';
import { getData, getRoute } from '../../../common/utils/router';
import NewsComponent from '../../../views/news/News/News';
import { getDefaultStaticProps, getLangPaths } from '../../api/_props';
import moment from 'moment/moment';
import { t } from '../../../common/components/T';
import UserContext from '../../../common/utils/getContext';
const project = require('../../../scripts/configs/project');

const NewsPage = ({ news, categories, translates, newsSettings }) => {
    const { routerLoader } = useContext(UserContext);
    const disabledParentTransition =
        routerLoader &&
        ((routerLoader?.to?.includes(`/news/category`) && getRoute(routerLoader?.from) === '/news') ||
            (routerLoader?.from?.includes(`/news/category`) && getRoute(routerLoader?.to) === '/news') ||
            (routerLoader?.from?.includes(`/news/category`) && routerLoader?.to?.includes(`/news/category`)));

    return (
        <Language translates={translates} page={'/news'}>
            <Single
                disabledTransition={disabledParentTransition}
                alias='news'
                translates={translates}
                title={t('mainPageTitle-news', 'Новости компании', '/news', translates)}
            >
                <NewsComponent newsSettings={newsSettings} news={news} categories={categories} />
            </Single>
        </Language>
    );
};
export async function getStaticProps({ params }) {
    const defaultProps = await getDefaultStaticProps(params?.lang, '/news', ['/news', '/']);
    if (!defaultProps?.props) {
        return defaultProps;
    }
    const { lang } = defaultProps?.props;
    const newsSettings = { size: 999 };
    const [categories, news] = await Promise.all([
        getData('/api/v1/news/categories?page[size]=999', false, lang, moment().format('1DD.ss.2MM.3mm')),
        getData(`/api/v1/news?page[size]=${newsSettings.size}`, false, lang, moment().format('1DD.ss.2MM.3mm'))
    ]);

    return {
        props: {
            ...defaultProps?.props,
            categories,
            news,
            newsSettings: newsSettings
        },
        revalidate: project?.revalidate
    };
}
export async function getStaticPaths() {
    const paths = await getLangPaths();

    return {
        paths,
        fallback: true
    };
}

export default NewsPage;
